import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector, useDispatch } from "react-redux";
import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import * as statusDispatch from '../../../store/extractor/actions';
import { getExtractorStatusSelector, getExtractorStatusPendingSelector } from "../../../store/extractor/selectors";
import LinearProgress from '@mui/material/LinearProgress';



export type StatusProps = {
    batchCode?: string,
    open: boolean,
    message?: string
};

const ProgressPopup = (props: StatusProps) => {
    const [dataRows, setDataRows] = useState<any>();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    // status list   

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        background: 'white',
        height: 200,
        p: 4,
    };

    const buttonStyle = {
        background: 'white',
        width: 700,
        ml: -4,
        p: 2,
    };

    return (
        <>
        
            <Modal
                open={props.open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
                    <LinearProgress />

                        <h2>Extractor {props.message ? props.message : 'Creation'} in Progress</h2>
                        {props.message ? 'The extractor is being updated. Please do not close the browser till it is done.' : 'The extractor is being created. Please do not close the browser till it is done.'}
                        
                            <Box sx={buttonStyle} display="flex" justifyContent="flex-end">
                            {/* <Button id="07ec0d6e-e5e9-4c9d-8dd5-3b41bff32e65" color="primary" variant="contained" onClick={handleClose} sx={{ ml: 2 }}>Dismiss</Button> */}
                        </Box>
                    </Typography>

                </Box>
            </Modal>
        </>

    )


};

export default ProgressPopup;